import styled from 'styled-components';
import { Persona } from '@fluentui/react';

export const TeamWidgetSuggestionContainer = styled.ul`
  position: absolute;
  top: 33px;
  right: 0.5rem;
  width: 280px;
  background: ${(props) => props.theme.suggestionBackground};
  border-radius: 3px;
  overflow: hidden;
  border-top: 3px solid #5b5fc7;
  z-index: 100;
  box-shadow:
    0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.11);

  li {
    z-index: 100;
    display: flex;
    align-items: center;
    padding: 0.5rem;
    list-style: none;
    background: ${(props) => props.theme.suggestionBackground};
  }

  li:hover,
  li:focus-visible,
  li:focus {
    outline: none;
    background: ${(props) => props.theme.suggestionHoverBackground};
    cursor: pointer;
  }
`;

export const TeamWidgetSuggestionPersona = styled(Persona)`
  position: static;
  z-index: 100;
  .ms-TooltipHost {
    font-weight: 600;
    font-size: 16px;
    color: ${(props) => props.theme.textMainColor};
    position: static;
  }

  .ms-Persona-initials span {
    font-size: 14px;
    font-weight: 600;
    position: static;
  }
  .ms-Persona-initials {
    background: #e9c7cd;
    color: #420610;
  }

  .ms-TooltipHost {
    display: none;
  }
`;

export const TeamWidgetSuggestionEmployeeName = styled.h3`
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.textMainColor};
`;

export const TeamWidgetSuggestionGroupNameHeader = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.textMainColor};
  margin: 10px 0;
  padding-left: 5px;
`;

export const TeamWidgetSuggestionOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  color: ${(props) => props.theme.textMainColor};
`;

export const TeamWidgetSuggestionGroupDisplayName = styled.h3`
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.textMainColor};
`;
